// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { BUTTON_CLASS_NAME } from "../../../core/constants/className";
import { useNavigate } from "react-router-dom";
import { ReactNode, useCallback, MouseEvent } from "react";
import "./Button.scss";

export interface NavigateBackButtonProps {
  readonly className?: string;
  readonly children?: ReactNode;
  readonly where?: string;
}

export function NavigateBackButton (props: NavigateBackButtonProps) {

  const className = props?.className;
  const navigate = useNavigate();
  //const where = props?.where;

  const onClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }

      navigate("../", { replace: true });
    },
    [navigate]
  );

  return (
    <button
      className={BUTTON_CLASS_NAME + (className ? ` ${className}` : "")}
      onClick={onClick}
    >{props?.children}</button>
  );
}


